<!-- 指定済み座席の表示 -->
<ng-container *ngIf="isSelected(seatNumber); else notSelectedSeat">
  <button
    *ngIf="!isChangeRestricted(seatNumber); else notChangeSeat"
    id="{{ isChargeableAsrSeat ? 'paid-' + seatNumber : seatNumber }}"
    class="{{
      isChargeableAsrSeat
        ? 'p-seatmap__seat p-seatmap__seat--paid is-selected'
        : 'p-seatmap__seat p-seatmap__seat--free is-selected'
    }}"
    (click)="onClickSeat(seatNumber)"
    [class.seat-disabled]="isNotClickable()"
    [disabled]="isNotClickable()"
    aria-live="polite"
  >
    <!-- 座席番号 -->
    <span class="u-visually-hidden">{{ seatNumber }}</span>

    <!-- 指定済み座席 -->
    <span
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.selecting' | staticMsg }}"
    ></span>

    <!-- 指定済み座席の搭乗者番号 -->
    <span class="p-seatmap__seat-passenger">
      <span class="p-seatmap__seat-passenger-num">{{
        getSelectingPassengerIndex() !== undefined ? getSelectingPassengerIndex()! + 1 : ''
      }}</span>
    </span>

    <!-- 窓なし席：左 -->
    <span
      *ngIf="isLeftNoWindowSeat(seatCharacteristicsCodes)"
      class="p-seatmap__seat-no-window p-seatmap__seat-no-window--left"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_WINDOW }}"
        alt="{{ 'm_static_message-label.nonWindow' | staticMsg }}"
        width="7"
        height="16"
    /></span>

    <!-- 窓なし席：右 -->
    <span
      *ngIf="isRightWindowSeat(seatCharacteristicsCodes)"
      class="p-seatmap__seat-no-window p-seatmap__seat-no-window--right"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_WINDOW }}"
        alt="{{ 'm_static_message-label.nonWindow' | staticMsg }}"
        width="7"
        height="16"
    /></span>

    <!-- リクライニングしない席 -->
    <span *ngIf="isNoReclineSeat(seatCharacteristicsCodes)" class="p-seatmap__seat-no-recline"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_RECLINE }}"
        alt="{{ 'm_static_message-label.impossibleReclining' | staticMsg }}"
        width="16"
        height="7"
    /></span>

    <!-- 非常口席 -->
    <span *ngIf="isExitDoorSeat(seatCharacteristicsCodes)" class="p-seatmap__seat-exitdoor"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_EXITDOOR }}"
        alt="{{ 'm_static_message-label.exitSeat' | staticMsg }}"
        width="10"
        height="6"
    /></span>

    <!-- フロントシート -->
    <span
      *ngIf="isFrontSeat()"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.forwardFacingSeat' | staticMsg }}"
    ></span>

    <!-- 後ろ向き席 -->
    <span
      *ngIf="false"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.backSeat' | staticMsg }}"
    ></span>

    <!-- バシネット席 -->
    <span
      *ngIf="isBassinetSeat(seatCharacteristicsCodes)"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.bassinetSeat' | staticMsg }}"
    ></span>
  </button>

  <!-- 指定済み変更不可席の場合の表示 -->
  <ng-template #notChangeSeat>
    <div class="p-seatmap__seat p-seatmap__seat--free is-unchangeable">
      <!-- 指定済み変更不可席 -->
      <span
        *ngIf="isChangeRestricted(seatNumber)"
        class="p-seatmap__seat-status u-visually-hidden"
        innerHTML="{{ 'm_static_message-label.unalterableSoSelected' | staticMsg }}"
      ></span>
      <!-- 指定済み変更不可席の搭乗者番号 -->
      <span class="p-seatmap__seat-passenger">
        <span class="p-seatmap__seat-passenger-num">{{
          getSelectingPassengerIndex() !== undefined ? getSelectingPassengerIndex()! + 1 : ''
        }}</span>
      </span>
    </div>
  </ng-template>
</ng-container>

<!-- 選択されていない座席の表示 -->
<ng-template #notSelectedSeat>
  <!-- 選択不可座席の条件を満たさない場合 -->
  <button
    *ngIf="!isUnavailable(seatNumber); else unAvailableSeat"
    id="notSelectedSeat {{ isChargeableAsrSeat ? 'paid-' + seatNumber : seatNumber }}"
    class="{{
      isChargeableAsrSeat ? 'p-seatmap__seat p-seatmap__seat--paid' : 'p-seatmap__seat p-seatmap__seat--free'
    }}"
    [class.is-before-change]="isBeforeChange(seatNumber)"
    [class.p-seatmap__seat--back]="isBackSeat()"
    [class.p-seatmap__seat--front]="isFrontSeat()"
    (click)="onClickSeat(seatNumber)"
    [class.seat-disabled]="isNotClickable()"
    [disabled]="isNotClickable() || isChangeRestricted(seatNumber)"
    aria-live="polite"
  >
    <!-- 座席番号 -->
    <span class="u-visually-hidden">{{ seatNumber }}</span>

    <!-- 読み上げラベル -->
    <span
      class="u-visually-hidden"
      innerHTML="{{ (isChargeableAsrSeat ? 'label.paidSeat' : 'label.freeSeat') | staticMsg }}"
    ></span>

    <!-- 選択可 -->
    <span
      *ngIf="!isUnavailable(seatNumber)"
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.selectable' | staticMsg }}"
    ></span>

    <!-- 変更前 -->
    <span
      *ngIf="isBeforeChange(seatNumber)"
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ (isChargeableAsrSeat ? 'label.changeBeforePaidSeat' : 'label.changeBeforeFreeSeat') | staticMsg }}"
    ></span>

    <!-- 変更前座席の搭乗者番号 -->
    <span *ngIf="isBeforeChange(seatNumber)" class="p-seatmap__seat-passenger"
      ><span class="p-seatmap__seat-passenger-num">{{
        getRegiseteredPassengerIndex() !== undefined ? getRegiseteredPassengerIndex()! + 1 : ''
      }}</span></span
    >

    <!-- 窓なし席：左 -->
    <span
      *ngIf="isLeftNoWindowSeat(seatCharacteristicsCodes)"
      class="p-seatmap__seat-no-window p-seatmap__seat-no-window--left"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_WINDOW }}"
        alt="{{ 'm_static_message-label.nonWindow' | staticMsg }}"
        width="7"
        height="16"
    /></span>

    <!-- 窓なし席：右 -->
    <span
      *ngIf="isRightWindowSeat(seatCharacteristicsCodes)"
      class="p-seatmap__seat-no-window p-seatmap__seat-no-window--right"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_WINDOW }}"
        alt="{{ 'm_static_message-label.nonWindow' | staticMsg }}"
        width="7"
        height="16"
    /></span>

    <!-- リクライニングしない席 -->
    <span *ngIf="isNoReclineSeat(seatCharacteristicsCodes)" class="p-seatmap__seat-no-recline"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_NO_RECLINE }}"
        alt="{{ 'm_static_message-label.impossibleReclining' | staticMsg }}"
        width="16"
        height="7"
    /></span>

    <!-- 非常口席 -->
    <span *ngIf="isExitDoorSeat(seatCharacteristicsCodes)" class="p-seatmap__seat-exitdoor"
      ><img
        src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_EXITDOOR }}"
        alt="{{ 'm_static_message-label.exitSeat' | staticMsg }}"
        width="10"
        height="6"
    /></span>

    <!-- フロントシート -->
    <span
      *ngIf="isFrontSeat()"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.forwardFacingSeat' | staticMsg }}"
    ></span>

    <!-- 後ろ向き席 -->
    <span
      *ngIf="false"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.backSeat' | staticMsg }}"
    ></span>

    <!-- バシネット席 -->
    <span
      *ngIf="false"
      class="p-seatmap__seat-info u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.bassinetSeat' | staticMsg }}"
    ></span>
  </button>

  <!-- 選択不可座席の条件を満たす場合 -->
  <ng-template #unAvailableSeat>
    <!-- 選択不可座席 -->
    <div *ngIf="!isInfantOnSeat" class="p-seatmap__seat is-unavailable">
      <span class="u-visually-hidden">{{ seatNumber }}</span>
      <span class="p-seatmap__seat-status"
        ><img
          src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_UNAVAILABLE_24 }}"
          alt="{{ 'm_static_message-label.unselectable' | staticMsg }}"
          width="14"
          height="14"
      /></span>
    </div>

    <!-- 幼児あり席 -->
    <div *ngIf="!!isInfantOnSeat" class="p-seatmap__seat is-infant">
      <span class="u-visually-hidden">{{ seatNumber }}</span>
      <span class="p-seatmap__seat-status">
        <img
          src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_INFANT_24 }}"
          alt="{{ 'm_static_message-reader.infantSeat' | staticMsg }}"
          width="24"
          height="24"
      /></span>
    </div>
  </ng-template>
</ng-template>
